export enum StudentPreviewToolbarTab {
  INFO = 'INFO',
  PROGRESS = 'PROGRESS',
  HISTORY = 'HISTORY',
  SPECIFIC_INFO = 'SPECIFIC_INFO',
  LAST_14_DAYS = 'LAST_14_DAYS',
  INTERNAL_NOTES = 'INTERNAL_NOTES',
  STUDY_PLAN = 'STUDY_PLAN',
  COURSES = 'COURSES'
}

export enum EditStudentToolbarTab {
  GENERAL_INFO = 'GENERAL_INFO',
  SPECIFIC_INFO = 'SPECIFIC_INFO',
  STUDY_PLAN = 'STUDY_PLAN',
  EXTRA_DATA = 'EXTRA_DATA'
}

export enum EStudentPaymentStatus {
  PAID = 'PAID',
  DOWNTURN = 'DOWNTURN',
  NON_PAYMENT = 'NON_PAYMENT',
  FORMER_STUDENT = 'FORMER_STUDENT'
}

export const STUDENT_PAYMENT_STATUS_VALUES = Object.values(EStudentPaymentStatus);

export enum EStudentsTableTabs {
  ALL_STUDENTS = 'ALL_STUDENTS',
  PROMOTIONS = 'PROMOTIONS'
}

export enum EContractMode {
  PROFESSIONAL = 'PROFESSIONAL',
  INDEPENDENT = 'INDEPENDENT',
  CONTRACT = 'CONTRACT',
  COMPANY = 'COMPANY'
}

export enum ETeacherStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ONBOARDING = 'ONBOARDING',
  OFFBOARDING = 'OFFBOARDING',
  TEMPORARY_LEAVE = 'TEMPORARY_LEAVE'
}

export enum EStudentSatisfactionStatus {
  PROMOTOR = 'PROMOTOR',
  NEUTRAL = 'NEUTRAL',
  DETRACTOR = 'DETRACTOR'
}

export enum EStudentConnectionStatus {
  WITHOUT_CONNECTION = 'WITHOUT_CONNECTION',
  SUPER_USER = 'SUPER_USER',
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT_ACTIVE',
  SLEEP = 'SLEEP',
  DISCONNECTED = 'DISCONNECTED'
}

export enum EStudentActivationStatus {
  ACTIVATED = 'ACTIVATED',
  NOT_ACTIVATED = 'NOT_ACTIVATED'
}

export const STUDENT_ACTIVATION_STATUS_VALUES = Object.values(EStudentActivationStatus);
